import {Component, Prop, Vue} from 'vue-property-decorator'
import {Theme} from "@/store";

@Component
class inputThemeMixin extends Vue {

  @Prop() readonly theme?: Theme
  get themeClass(): string {
    let theme = this.theme;
    return theme ? ('themed-' + theme) : '';
  }

}

export default inputThemeMixin
